import axios from 'axios';

const API_BASE_URL = '/api/outlook';

export const checkTokenStatus = async (): Promise<{ isConnected: boolean, username: string | null }> => {
  const response = await axios.get<{ isConnected: boolean, username: string | null }>(`${API_BASE_URL}/status`);
  return response.data;
};

export const connectAccount = (onSuccess: () => void) => {
  const width = 600, height = 700;
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;
  const url = `${process.env.REACT_APP_BACKEND_HOST_URL}${API_BASE_URL}/connect`;
  console.log(url);
  const options = `width=${width},height=${height},top=${top},left=${left}`;
  const popup = window.open(url, 'OutlookOAuth', options);
  console.log("Pop-Up Window Opened")

  const handleMessage = (event: MessageEvent) => {
    console.log(event.origin, process.env.REACT_APP_BACKEND_HOST_URL, event.data)
    if (event.origin === process.env.REACT_APP_BACKEND_HOST_URL && event.data === "oauth:success") {
      console.log("OAuth Success");
      if (popup) {
        popup.close();
      }
      window.removeEventListener('message', handleMessage);
      onSuccess();
    }
  };

  window.addEventListener('message', handleMessage, false);
};

export const removeToken = async (): Promise<void> => {
  await axios.delete(`${API_BASE_URL}`);
};
